import { createReducer } from 'redux-starter-kit';
import {putDashboardData, updateIssueData, updateRateData, updateReasonData} from './dashboardDataActions';


export const selectDashboardData = state => state.via.domain.dashboardData;

/**
 * A reducer for managing the Damage Areas in the domain.
 */
const dashboardDataReducer = createReducer(null, {
  [putDashboardData]: (state, action) => action.payload,
  [updateRateData]: (state, action) => {
    const rateData = action.payload;
    const currenDashData = { ...state };
    currenDashData.inspectionsByDate = rateData;
    return currenDashData;
  },
  [updateReasonData]: (state, action) => {
    const reasonData = action.payload;
    const currenDashData = { ...state };
    currenDashData.reasonsByDate = reasonData;
    return currenDashData;
  },
  [updateIssueData]: (state, action) => {
    const issueData = action.payload;
    const currenDashData = { ...state };
    currenDashData.defectsByDate = issueData;
    return currenDashData;
  },
});

export default dashboardDataReducer;
